import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

const THEME_STORAGE_KEY = 'tuneswell_theme';

export const THEMES = {
  DARK: 'dark',
  LIGHT: 'light',
  OASIS: 'oasis', // Renamed from NATURAL
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    // Load theme from localStorage on mount
    let savedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    // Migrate old 'natural' theme to 'oasis'
    if (savedTheme === 'natural') {
      savedTheme = THEMES.OASIS;
      localStorage.setItem(THEME_STORAGE_KEY, savedTheme);
    }
    // Validate theme is one of the valid options
    const validThemes = Object.values(THEMES);
    const initialTheme = savedTheme && validThemes.includes(savedTheme) 
      ? savedTheme 
      : THEMES.DARK; // Default to dark if invalid
    // Set initial data-theme attribute on body
    if (typeof document !== 'undefined') {
      document.body.setAttribute('data-theme', initialTheme);
    }
    return initialTheme;
  });

  useEffect(() => {
    // Save theme to localStorage whenever it changes
    localStorage.setItem(THEME_STORAGE_KEY, theme);
    // Set data-theme attribute on body for CSS variable support
    if (typeof document !== 'undefined') {
      document.body.setAttribute('data-theme', theme);
    }
  }, [theme]);

  const changeTheme = (newTheme) => {
    // Validate theme is one of the valid options
    const validThemes = Object.values(THEMES);
    if (validThemes.includes(newTheme)) {
      setTheme(newTheme);
    } else {
      console.warn(`Invalid theme: ${newTheme}. Using default theme.`);
      setTheme(THEMES.DARK);
    }
  };

  return (
    <ThemeContext.Provider value={{ theme, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

